class SectionSoftwareDownloadNew {
  constructor () {
    this.selectorDevice = document.getElementById('SDN-SEL-DEVICE')
    this.selectorOS = document.getElementById('SDN-SEL-OS')
    this.leftRadios = document.querySelectorAll('.SDN__left-select-item-input')
    this.softwareItems = document.querySelectorAll(
      '.snippet-software-info-item'
    ) // 软件卡片
    this.contentContainers = document.querySelectorAll('.SDN__right-content')
    this.leftWrapper = document.querySelector('.SDN__left-wrapper')
    this.breadnavStickyInner = document.querySelector(
      '.section-breadnav-sticky__inner'
    )
    this.filterBtnSubmenu = document.querySelector('.SDN__toggle-btn')

    this.__val_device__ = '' // 设备筛选值
    this.__val_os__ = '' // os 筛选值，如 os-win
    this.isUpdating = false // 同步更新锁

    this.init()
  }

  init () {
    window.addEventListener('DOMContentLoaded', () => {
      this.initSelect2()
      this.initSelect2Change()
      this.initListenRadiosChange()
      this.updateLeftWrapperTop()
      this.initFilterBtn()
      this.parseHashParams()

      window.addEventListener('scroll', () => this.updateLeftWrapperTop(), {
        passive: true
      })
      window.addEventListener('resize', () => this.updateLeftWrapperTop())
    })
  }

  // 移动端筛选按钮
  initFilterBtn () {
    this.filterBtnSubmenu.addEventListener('click', function () {
      const contentWrapper = this.closest('.SDN__left-toggle-wrapper')

      if (contentWrapper.dataset.toogleStatusSubmenu === 'close') {
        contentWrapper.dataset.toogleStatusSubmenu = 'open'
      } else {
        contentWrapper.dataset.toogleStatusSubmenu = 'close'
      }
    })
  }

  // 左侧筛选栏保持在 breadnav sticky 下方 18px
  updateLeftWrapperTop () {
    if (!this.leftWrapper || !this.breadnavStickyInner) return

    const breadnavRect = this.breadnavStickyInner.getBoundingClientRect()
    this.leftWrapper.style.top = breadnavRect.bottom + 18 + 'px'
  }

  // 初始化 select2 筛选框
  initSelect2 () {
    $(this.selectorDevice).select2()
    $(this.selectorOS).select2({
      minimumResultsForSearch: -1 // 不显示搜索框
    })
  }

  // 监听 select2 的选中事件
  initSelect2Change () {
    $(this.selectorDevice).on('select2:select', e => {
      if (this.isUpdating) return
      const data = e.params.data
      this.__val_device__ = data.id || ''

      this.isUpdating = true
      this.leftRadios.forEach(radio => {
        radio.checked = radio.value === this.__val_device__
      })
      this.isUpdating = false
      this.filterToggleDom()
    })

    $(this.selectorOS).on('select2:select', e => {
      if (this.isUpdating) return
      const data = e.params.data
      this.__val_os__ = data.id || ''
      this.filterToggleDom()
    })
  }

  // 监听左边 radio 的 change：与设备下拉同步，并触发筛选
  initListenRadiosChange () {
    this.leftRadios.forEach(radio => {
      radio.addEventListener('change', e => {
        if (this.isUpdating) return
        this.__val_device__ = e.target.value || ''

        this.isUpdating = true
        $(this.selectorDevice).val(this.__val_device__).trigger('change')
        this.isUpdating = false
        this.filterToggleDom()
      })
    })
  }

  /**
   * 根据设备 / OS 筛选显示隐藏
   * - 两者皆空：全部卡片 + 全部系统行
   * - 仅 OS：只保留支持该系统的卡片，且只显示对应系统行
   * - 仅设备：只保留兼容该设备的系统行；无匹配行则隐藏整卡
   * - 两者都有：只显示同时匹配的系统行；无匹配行则隐藏整卡
   * - 选中设备且该设备在对应系统 coming soon 列表中：下载按钮改为 Coming soon
   */
  filterToggleDom () {
    const device = this.__val_device__
    const osFilter = this.__val_os__ // os-win
    const osKey = osFilter ? osFilter.replace(/^os-/, '') : '' // win

    this.softwareItems.forEach(card => {
      const cardOsDom = card.querySelectorAll('.SDNI__os-item')
      let visibleRowCount = 0

      cardOsDom.forEach(row => {
        const rowOs = row.dataset.os // win / mac / android / ios
        const devices = this.getListFromDataset(
          card.dataset[`${rowOs}SupportedDevice`]
        )
        const comingSoonList = this.getListFromDataset(
          card.dataset[`${rowOs}ComingSoon`]
        )

        const osMatch = !osKey || rowOs === osKey
        // all-3d-scanners 表示支持全部型号
        const deviceMatch = !device || (
          devices.includes(device) ||
          (device !== 'accessories' && devices.includes('all-3d-scanners'))
        )
        const shouldShow = osMatch && deviceMatch

        row.classList.toggle('active', shouldShow)

        if (shouldShow) {
          visibleRowCount++
          this.toggleComingSoon(row, device && comingSoonList.includes(device))
        } else {
          this.toggleComingSoon(row, false)
        }
      })

      // 无筛选时全部显示；有筛选时至少有一行匹配才显示卡片
      const showCard = !device && !osFilter ? true : visibleRowCount > 0
      card.classList.toggle('active', showCard)
    })

    this.updateEmptyStates()
  }

  getListFromDataset (value) {
    if (!value) return []
    return value.split(',').filter(Boolean)
  }

  /**
   * coming soon：所选型号在 coming soon 列表时，只显示 --cs；否则显示已存在的下载按钮
   * @param {Element} row - .SDNI__os-item
   * @param {boolean} isComingSoon
   */
  toggleComingSoon (row, isComingSoon) {
    const comingSoonEl = row.querySelector('.SDNI__os-dl--cs')
    const downloadBtn = row.querySelector('.SDNI__os-dl--rv')
    const googleBtn = row.querySelector('.SDNI__os-dl--google')

    if (comingSoonEl) {
      comingSoonEl.classList.toggle('active', isComingSoon)
    }
    if (downloadBtn) {
      downloadBtn.classList.toggle('active', !isComingSoon)
    }
    if (googleBtn) {
      googleBtn.classList.toggle('active', !isComingSoon)
    }
  }

  // 某一分类下无可见卡片时，显示 empty 提示
  updateEmptyStates () {
    this.contentContainers.forEach(container => {
      const hasVisible = container.querySelector(
        '.snippet-software-info-item.active'
      )
      const emptyNote = container.querySelector('.SDN__software--empty')
      if (emptyNote) {
        emptyNote.classList.toggle('active', !hasVisible)
      }
    })
  }
  
  // 解析hash参数
  parseHashParams () {
    const hash = window.location.hash
    if (!hash) {
      return
    }
    const hashDom = document.querySelector(hash)
    if (hashDom) {
      jumpToTarget(`${window.location.hash}`)
    }
  }
}

new SectionSoftwareDownloadNew()
